<template>
    <div class="type-select">
        <p
            v-for="(item, index) in options"
            class="item"
            :class="{active: `${item.id}`===`${newSelect}`}"
            :key="index"
            @click="handleSelect(item)"
        >{{item.name}}</p>
    </div>
</template>

<script>
    export default {
        name: "type-select",
        props: {
            options: Array,
            select: [String, Number]
        },
        watch:{
            select(vl){this.newSelect = vl},
            newSelect(vl){this.$emit('update:select',vl)}
        },
        data(){
            return {
                newSelect: this.select
            }
        },
        methods: {
            handleSelect(item){
                const {id} = item
                this.newSelect = id
            }
        }
    }
</script>

<style lang="scss" scoped>
.type-select{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #303133;
    height: 40px;
    margin: 6px 20px 20px;
    border-radius: 4px;

    .item{
        display: flex;
        flex: 1;
        margin: 3px 0px;
        margin-left: 3px;
        color: rgba(255,255,255,.5);
        font-size: 14px;
        font-weight: 400;
        border-radius: 2px;
        transition: all .2s linear;
        line-height: 34px;
        justify-content: center;
        cursor: pointer;

        &:last-child{
            margin-right: 3px;
        }

        &:hover, &.active{
            color: #303133;
            background-color: white;
        }
    }
}
</style>
